const marketList = ()=>import('./views/marketList.vue');
const marketEdit = ()=>import('./views/marketEdit.vue');
const empty = () => import("@core/components/empty.vue");
const marketHome = ()=>import("./views/marketHome.vue");

const issueList = () => import("./views/issueList.vue");
const issueEdit = () => import("./views/issueEdit.vue");
const marketLibraryList = () => import("./views/marketLibraryList.vue");
const weChatEmpower = () => import("./views/weChatEmpower.vue");
const marketCategory = () => import("./views/marketCategory.vue");
const marketCategoryEdit = () => import("./views/marketCategoryEdit.vue");
export default {
  path: 'market',
  name: 'marketBox',
  component: empty,
    children:[
      {
        path: '/marketList',//营销内容列表
        name: 'marketList',
        component: marketList,
        meta: {
          title: '营销内容列表',
          root: '/appCenter'
        },
      },
      {
        path: '/marketEdit',
        name: 'marketEdit',
        component: marketEdit,
        meta: {
          parentRoot: '/marketList', // 导航高亮
          root: '/appCenter'
        }
      },
      {
        path: '/marketHome',//营销管理首页
        name: 'marketHome',
        component: marketHome,
        meta: {
          title: '营销内容首页',
          root: '/appCenter'
        }
      },
      {
        // 签名列表
        path: '/issueList',
        name: 'issueList',
        component: issueList,
        meta: {
          parentRoot: '/issueList',
          root: '/appCenter'
        }
      },
      {
        // 编辑签名
        path: '/issueList/issueEdit',
        name: 'issueEdit',
        component: issueEdit,
        meta: {
          parentRoot: '/issueList',
          root: '/appCenter'
        }
      },
      {
        // 员工营销库列表
        path: '/marketLibraryList',
        name: 'marketLibraryList',
        component: marketLibraryList,
        meta: {
          parentRoot: '/marketLibraryList',
          root: '/appCenter'
        }
      },
      // {
      //   // 微信授权
      //   path: '/weChatEmpower',
      //   name: 'weChatEmpower',
      //   component: weChatEmpower,
      //   meta: {
      //     parentRoot: '/weChatEmpower',
      //     root: '/appCenter'
      //   }
      // },
      {
        // 营销分类
        path: '/marketCategory',
        name: 'marketCategory',
        component: marketCategory,
        meta: {
          parentRoot: '/marketCategory',
          root: '/appCenter'
        }
      },
      {
        // 添加、编辑营销分类
        path: '/marketCategoryEdit',
        name: 'marketCategoryEdit',
        component: marketCategoryEdit,
        meta: {
          parentRoot: '/marketCategory',
          root: '/appCenter'
        }
      }
    ]
}


// WEBPACK FOOTER //
// ./src/core/modules/market/router.js